// extracted by mini-css-extract-plugin
export default {"zoomModal":"Aba-z","image":"Bba-z","button":"Cba-z","isOverlayShown":"Dba-z"};